var _path, _path2, _path3;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

var SvgLive = function SvgLive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.58 13.65a2.24 2.24 0 0 1-3.16-3.15 2.23 2.23 0 0 1 3.16 3.15zm3.05 3.37c-.27 0-.54-.1-.75-.3a1.06 1.06 0 0 1 0-1.5 4.4 4.4 0 0 0 0-6.29 1.06 1.06 0 0 1 1.5-1.5 6.51 6.51 0 0 1 0 9.28c-.2.21-.48.31-.75.31z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.03 20.15a1.06 1.06 0 0 1-.75-1.81 8.79 8.79 0 0 0 2.6-6.27c0-2.36-.92-4.59-2.6-6.26a1.06 1.06 0 0 1 1.5-1.5A10.9 10.9 0 0 1 23 12.07a10.9 10.9 0 0 1-3.22 7.77c-.2.2-.48.3-.75.3zM7.37 17.02c-.27 0-.54-.1-.75-.3a6.51 6.51 0 0 1 0-9.29 1.06 1.06 0 1 1 1.5 1.5 4.4 4.4 0 0 0 0 6.28 1.06 1.06 0 0 1-.75 1.81z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.97 20.15c-.27 0-.54-.1-.75-.31A10.9 10.9 0 0 1 1 12.07a10.9 10.9 0 0 1 3.22-7.76 1.06 1.06 0 1 1 1.5 1.5 8.79 8.79 0 0 0-2.6 6.26c0 2.37.92 4.6 2.6 6.27a1.06 1.06 0 0 1-.75 1.8z"
  })));
};

export default SvgLive;